import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setBearerToken, formatError } from "./api";

const AuthContext = createContext({ user: null, login: () => {}, logout: () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch {
        setUser(null);
      }
    })();
  }, []);

  const login = async (email, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.access_token) setBearerToken(data.access_token);
      setUser(data.user);
      return true;
    } catch (e) {
      setError(formatError(e.response?.data?.detail, "Invalid email or password"));
      return false;
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setBearerToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, error }}>{children}</AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
